<div [id]="slice.sectionId" class="margin-on-scroll">
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>

<ng-template #contentTemplate>
  <div class="container py-8 lg:py-16">
    @if (slice.title) {
      <div data-source="prismic" class="mx-4 text-center mb-9" [innerHtml]="slice.title"></div>
    }

    <div class="mx-4 lg:mx-5">
      <div
        class="grid grid-cols-1 gap-4 lg:gap-8 mx-auto"
        [ngClass]="{
          'lg:grid-cols-2 lg:max-w-6xl': boxSize === 'small',
          'xl:grid-cols-3 lg:max-w-full': boxSize === 'small' && slice.offers.length === 3,
        }"
      >
        <ng-container *ngTemplateOutlet="offersTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #offersTemplate>
  @for (offer of slice.offers; track offer) {
    <lib-offer-box
      [offer]="offer"
      [size]="boxSize"
      [lazyLoadImage]="!slice.isHeadSlice"
      [ngClass]="[slice.displaySize]"
      (offerClick)="onOfferClick($event)"
      class="offer-box"
    >
    </lib-offer-box>
  }
</ng-template>
